function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "180.023px",
    viewBox: "0 0 200 180.023",
    style: {
      enableBackground: "new 0 0 200 180.023"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "change1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6302C"
    },
    d: "M199.326,44.459c-11.27-57.967-81.908-58.936-99.326-4.746 C82.582-14.476,11.942-13.508,0.674,44.459C-9.551,97.051,100,180.024,100,180.024S209.55,97.051,199.326,44.459z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.286db198ed3962d7ec4724276f411c63.svg";
export { ForwardRef as ReactComponent };